import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../client";

const BASE_URL = "shared/FormElements";

export const getFormElements = createAsyncThunk(
  "FormElements/list",
  async () => (await api.get(BASE_URL)).data,
);

export const getFormElement = createAsyncThunk(
  "FormElements/get",
  async (id) => (await api.get(`${BASE_URL}/${id}`)).data,
);

export const saveFormElement = createAsyncThunk(
  "FormElements/save",
  async (data) => (await api.post(BASE_URL, data)).data,
);

export const updateFormElement = createAsyncThunk(
  "FormElements/update",
  async (data) => (await api.put(`${BASE_URL}/${data.id}`, data)).data,
);

export const deleteFormElement = createAsyncThunk(
  "FormElements/delete",
  async (id) => (await api.delete(`${BASE_URL}/${id}`)).data,
);

const addCases = (builder, thunk, onFulfilled) =>
  builder
    .addCase(thunk.pending, (state) => {
      state.isLoading = true;
      state.message = null;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.isLoading = false;
      onFulfilled(state, action);
    })
    .addCase(thunk.rejected, (state, action) => {
      state.isLoading = false;
      state.message = action.payload ?? action.error.message;
    });

const initialState = {
  list: [],
  formElement: null,
  isLoading: false,
  message: null,
};

const slice = createSlice({
  name: "formElements",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addCases(builder, getFormElements, (state, action) => {
      state.list = action.payload.data;
    });
    addCases(builder, getFormElement, (state, action) => {
      state.formElement = action.payload.data;
    });
    addCases(builder, saveFormElement, (state, action) => {
      state.message = action.payload.message;
    });
    addCases(builder, updateFormElement, (state, action) => {
      state.message = action.payload.message;
    });
    addCases(builder, deleteFormElement, (state, action) => {
      state.message = action.payload.message;
    });
  },
});

export default slice.reducer;
